module.exports = __webpack_public_path__ + "static/image-02-b@2x-5fa0f2e3b6aac9e6f8f8facd04ec6052.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/deliveroo/image-02-b@2x.jpg
// module id = 356
// module chunks = 3627797113349 20562973939449 33019919093843